import { AppRouteProps } from "@bsm/component";
import { BankCreateContainer } from "./container/BankCreateContainer";

export const BankCreateRoute = [
    {
        path: "-1",
        element: <BankCreateContainer />
    },
] as Array<AppRouteProps>